import { useCallback, type FC } from "react";

import { EnvironmentSecretsTable } from "@/components/environments/EnvironmentSecretsTable";
import { Button } from "@/components/flexkit/Button";
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/podkit/modal/Modal";
import { SecretsFrame } from "@/components/secrets/SecretsCard";
import { TrackLocations } from "@/hooks/use-segment";
import { useEnvironment } from "@/queries/environment-queries";
import { useListUserSecrets } from "@/queries/secret-queries";
export const EnvironmentSecretsModal: FC<{ environmentId: string; onClose: () => void }> = ({
    environmentId,
    onClose,
}) => {
    const { data: environment } = useEnvironment(environmentId);
    const { data: userSecrets } = useListUserSecrets();

    const handleOpenChange = useCallback(
        (nextOpen: boolean) => {
            if (!nextOpen) {
                onClose();
            }
        },
        [onClose],
    );

    return (
        <Dialog open onOpenChange={handleOpenChange}>
            <DialogContent
                className="max-w-[600px]"
                data-testid="environment-secrets-modal-content"
                data-track-location={TrackLocations.EnvironmentSecretsModal}
            >
                <DialogHeader>
                    <DialogTitle>Secrets</DialogTitle>
                    <DialogDescription>Secrets available in this environment</DialogDescription>
                </DialogHeader>

                <DialogBody className="overflow-x max-w-full">
                    <SecretsFrame>
                        {environment && userSecrets && (
                            <EnvironmentSecretsTable environment={environment} userSecrets={userSecrets.secrets} />
                        )}
                    </SecretsFrame>
                </DialogBody>

                <DialogFooter className="sm:justify-end">
                    <DialogClose asChild>
                        <Button type="button" variant="secondary">
                            Close
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
